<template>
  <div>
    <div v-if="loading" style="text-align: center; padding: 40px;">
      <i class="el-icon-loading"></i> Loading...
    </div>
    <DetailDHL
      v-else-if="serviceType === 'U-S-DH'"
      :id="id"
      :platform_order_sn="platform_order_sn"
      :invoiceData="invoiceData"
      :countryWhitelist="countryWhitelist"
    />
    <DetailFedEx
      v-else-if="isFedEx"
      :id="id"
      :platform_order_sn="platform_order_sn"
      :invoiceData="invoiceData"
      :countryWhitelist="countryWhitelist"
    />
    <Detail
      v-else
      :id="id"
      :platform_order_sn="platform_order_sn"
      :invoiceData="invoiceData"
      :countryWhitelist="countryWhitelist"
    />
  </div>
</template>

<script>
import { invoiceDetails } from '@/api/invoice'
import { fCity } from '@/api/common'
import Detail from './detail.vue'
import DetailDHL from './detailDHL.vue'
import DetailFedEx from './detailFedEx.vue'

export default {
  components: {
    Detail,
    DetailDHL,
    DetailFedEx
  },
  props: {
    id: {
      type: [Number, String],
      default: ''
    },
    order_sn: {
      type: [Number, String],
      default: ''
    },
    platform_order_sn: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      loading: true,
      serviceType: '',
      invoiceData: null,
      // 系统支持的"产地"国家英文全名白名单（来自 fCity 接口），子组件用它对 chandi 做匹配校验
      countryWhitelist: []
    }
  },
  computed: {
    // FedEx 渠道：service_type 为 JD-FED 或 ZD-FED
    isFedEx() {
      return ['JD-FED', 'ZD-FED'].includes(this.serviceType)
    }
  },
  mounted() {
    // 并行加载发票数据和国家白名单，二者都完成后再关闭 loading
    Promise.all([
      this.getInvoiceDetails(),
      this.getCountryWhitelist()
    ]).finally(() => {
      this.loading = false
    })
  },
  methods: {
    getInvoiceDetails() {
      return invoiceDetails({
        user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
        id: this.id,
        order_sn: this.order_sn
      }).then(res => {
        if (res.code == 1) {
          this.invoiceData = res.data
          this.serviceType = res.data.order_info.service_type || ''
        }
      }).catch(() => {})
    },
    // 拉取国家白名单（与"产地"下拉数据源一致）
    getCountryWhitelist() {
      return fCity().then(res => {
        if (res && res.code == 1 && Array.isArray(res.data)) {
          this.countryWhitelist = res.data.map(c => c && c.name).filter(Boolean)
        }
      }).catch(() => {})
    }
  }
}
</script>
